import { render } from "./Index.vue?vue&type=template&id=65b0ce31&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=65b0ce31&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0ce31"]])

export default __exports__